export default "__VITE_ASSET__f34b390a__"